<template>
  <div>
  <el-dialog :visible="show">
    <ModalHeader slot="title" title="Tải lên danh sách câu thông dụng" />

    <vue2-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" >
    </vue2-dropzone>
    <el-row slot="footer" class="upload-button-container">
      <el-button type="default" @click="closeAll"> Hủy bỏ</el-button>
      <CommonButton :ref="refs.UPLOAD_BLACKLIST" type="primary" @click="handleUploadFile">
        Tải lên
      </CommonButton>
    </el-row>
  </el-dialog>

  </div>
</template>

<script>

import ModalHeader from '@/components/common/ModalHeader'
import FAIcon from '@/components/common/FAIcon'
import vue2Dropzone from 'vue2-dropzone'
import { apiUploadBlacklistFile } from '@/services/admin_dashboard_service'
import CommonButton from '@/components/common/CommonButton'

export default {
  name: 'UploadBlacklistModel',
  components: {ModalHeader, FAIcon, vue2Dropzone, CommonButton},
  data: () => {
    return {
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        autoProcessQueue: false,
        thumbnailWidth: 150,
        maxFilesize: 100,
        maxFiles: 1,
        addRemoveLinks: true,
        dictRemoveFile: 'Loại bỏ',
        dictInvalidFileType: 'Sai định dạng file',
        dictMaxFilesExceeded: 'Số lượng file tải lên vượt quá quy định',
        dictDefaultMessage: 'Tải file text chứa các câu văn thông dụng (mỗi câu nằm trong một dòng)',
        acceptedFiles: '.txt',
      },
      show: false,
      refs: {
        UPLOAD_BLACKLIST: 'UPLOAD_BLACKLIST'
      }
    }
  },
  methods: {
    showModal() {
      this.show = true
    },
    closeAll() {
      this.show = false
    },
    async handleUploadFile() {
      if (this.$refs.myVueDropzone.getAcceptedFiles()[0]) {
        this.$refs[this.refs.UPLOAD_BLACKLIST].setLoading(true)
        let res = await apiUploadBlacklistFile(this.$refs.myVueDropzone.getAcceptedFiles()[0])
        if (res != null) {
          this.$refs.myVueDropzone.removeAllFiles()
          this.$message.success('Đã cập nhật danh sách câu')
        } else {
          this.$message.error('Có lỗi xảy ra')
        }
        this.$refs[this.refs.UPLOAD_BLACKLIST].setLoading(false)
        this.closeAll()
      } else {
        this.$message.error('Không có file dữ liệu')
      }

    }
  }
}
</script>

<style scoped>

</style>
